import {
  Box,
  Button,
  ButtonGroup,
  Center,
  HStack,
  IconButton,
  Stack,
  Text,
} from "@chakra-ui/react";
import { MaterialIcon } from "../../../components/shared/MaterialIcon";
import { ICohort } from "../../registries/models/Cohort";

interface IProps {
  cohort: ICohort;
  onOpen: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
}

const CohortCard = ({ cohort, onOpen, onEdit, onDelete }: IProps) => {
  const handleOnEdit = (evt) => {
    evt.stopPropagation();
    if (onEdit) {
      onEdit();
    }
  };
  const handleOnDelete = (evt) => {
    evt.stopPropagation();
    if (onDelete) {
      onDelete();
    }
  };

  return (
    <Box
      h="full"
      w="full"
      border={"1px"}
      rounded="md"
      minH={"16rem"}
      px={8}
      pt={8}
      pb={4}
      onClick={onOpen}
      bg="bg.main"
      borderColor="border"
      cursor={"pointer"}
      shadow="sm"
      _hover={{
        color: "text",
        bg: "bg.high",
      }}
    >
      <Stack h="full" spacing={6} alignItems="center">
        <Center flex={1} w="full" maxH="56" minH="56">
          <MaterialIcon
            color="text.primary"
            name="join_inner"
            fontSize="6rem"
          />
        </Center>

        <Stack spacing="1" flex={1}>
          <Text fontWeight="bold" fontSize="xl" textAlign={"center"}>
            {cohort.title}
          </Text>
          <Text
            noOfLines={2}
            fontSize="md"
            textAlign={"center"}
            color="text.soft"
          >
            {cohort.description}
          </Text>
        </Stack>
        <ButtonGroup
          w="full"
          size="sm"
          variant={"outline"}
          display="flex"
          flexDirection={"row-reverse"}
          justifyContent={"space-between"}
        >
          <Button
            onClick={onOpen}
            rightIcon={<MaterialIcon name="arrow_right_alt" fontSize="1rem" />}
          >
            Open
          </Button>

          <HStack spacing={2}>
            {onEdit && (
              <IconButton
                onClick={handleOnEdit}
                icon={<MaterialIcon name="settings" fontSize="1rem" />}
                aria-label="settings"
              ></IconButton>
            )}
            {onDelete && (
              <IconButton
                onClick={handleOnDelete}
                icon={<MaterialIcon name="delete" fontSize="1rem" />}
                aria-label="settings"
              ></IconButton>
            )}
          </HStack>
        </ButtonGroup>
      </Stack>
    </Box>
  );
};

export default CohortCard;
